// extracted by mini-css-extract-plugin
export default {"msgM":"_14f0626374"};